import React, {useEffect, useState} from "react"
import DuplaConfirmacao from "./DuplaConfirmacao"
import {subscribeDuplaConfirmacao} from "./DuplaConfirmacaoBus"

export function DuplaConfirmacaoListener() {
    const [value, setValue] = useState({
        open: false,
        cancel: () => {
        },
        confirm: () => {
        },
        title: "",
        description: "",
        confirmTextButton: "",
        cancelIcon: "",
        confirmIcon: ""
    })

    useEffect(() => {
        const unsubscribe = subscribeDuplaConfirmacao(
            ({
                 open,
                 cancelAction,
                 confirmAction,
                 title,
                 description,
                 confirmTextButton,
                 cancelIcon,
                 confirmIcon,
             }) => {
                setValue({
                    open,
                    cancel: cancelAction,
                    confirm: confirmAction,
                    title,
                    description,
                    confirmTextButton: confirmTextButton || "Sim",
                    cancelIcon,
                    confirmIcon,
                })
            }
        )

        return () => unsubscribe()
    }, [])

    const cancelAction = () => {
        setValue({...value, open: false})

        if (typeof value.cancel === "function") {
            value.cancel()
        }

    }

    const confirmAction = () => {
        if (typeof value.confirm === "function") {
            value.confirm()
        }
        setValue({...value, open: false})
    }

    return (
        <DuplaConfirmacao
            open={value.open}
            title={value.title}
            description={value.description}

            cancel={cancelAction}
            cancelIcon={value.cancelIcon}

            confirmIcon={value.confirmIcon}
            confirm={confirmAction}
            confirmTextButton={value.confirmTextButton}

            action={value.action}
        />
    )
}